import type { FaireProductEntity } from "../../entity_types/product";

export const p_pqxuhvg9na: FaireProductEntity = {
  token: "p_pqxuhvg9na",
  type: "product",
  name: "KeaBabies 3-Pack Warmzy Baby Beanies (Pecan, M)",
  brandToken: "b_awf1h1ea9q",
  brandName: "KeaBabies",
  imageUrl:
    "https://cdn.faire.com/fastly/7e2b6b3b4acd79e910c5677451012d11797dd2e16e142d1605befff619d36f9d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a67632d178a1364cd44db8bfba13ebc5777f92caeb09a95d49d4460017b3f867.jpeg",
    "https://cdn.faire.com/fastly/514df1431caa31d18814601ab3b03ff2b752481bfbdbb13639bfad9cebb028da.jpeg",
    "https://cdn.faire.com/fastly/f5afb60b54b4a6303252e64ab5f4dc100bd0db9168b47cd0a4f038fa2e2a99bf.jpeg",
    "https://cdn.faire.com/fastly/f672f33e949a950ec06bf5e423a9ea4539553fc35ca7f7016d48d681e9c8d5cb.jpeg",
    "https://cdn.faire.com/fastly/6c18d826b8ffccab5be1ae0f314b40e4b16c273903817b44840785b5873ce691.jpeg",
    "https://cdn.faire.com/fastly/dbcb2d5f2efda0a280181dd7bee5f30ae69340beb41ae40fcaa845723efcf16a.jpeg",
    "https://cdn.faire.com/fastly/ff3647aafead4c56686d65fe5e52d742a1b53d97f26f6e923e1185142a955165.jpeg",
    "https://cdn.faire.com/fastly/b4f6858da7b5ebaab3c05acb4b7703f461739e12ecdc862e923d3b664c3e10b3.jpeg",
  ],
  priceDollars: 7.98,
  description:
    "Designed for unlimited fun, KeaBabies Warmzy Baby Beanies allow your child to stay active while staying warm and cozy during winter! These stretchy baby hats come in two sizes and are suitable for newborns, babies, and toddlers aged 0-36 months. These kids hats are machine washable and shrink-proof.\t\n\n- Soft and lightweight baby hats\t\n- Covers your baby’s head and ears snugly\t\n- Stretchy baby beanie that fits S (0-6 months) and M (6-36 months)\t\n- Machine washable and air dries quickly\t\n- Everyday baby girl and boy essentials for fall and winter",
  tags: [],
  msrpDollars: 15.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:46.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
